import React from "react";
import ActivityLogDrawer, {
  formatValueByField,
} from "../../../../components/ACS-Dashboard/ACS-Blocks/ActivityLogDrawer";

/**
 * Order-side wrapper around the shared activity timeline drawer.
 * Mirrors ShipmentActivity, minus the inline preview section.
 */
const OrderActivity = ({
  isActivityLoading,
  activityLogs,
  formatDisplayDate,
  isOpen,
  onClose,
}) => (
  <ActivityLogDrawer
    isOpen={isOpen}
    onClose={() => onClose?.()}
    logs={Array.isArray(activityLogs) ? activityLogs : []}
    formatDisplayDate={formatDisplayDate}
    isActivityLoading={isActivityLoading}
    eyebrow="Order Timeline"
    title="Activity Log"
    entityLabel="Order"
    entityNumberKey="orderNumber"
    // Order logs mix amounts with identifiers (PO Number, Release Number, ...), and the
    // backend already normalizes numbers — so only format the money/measure fields.
    valueFormatter={formatValueByField}
  />
);

export default OrderActivity;
